import { Component, OnInit } from '@angular/core';
import { MechanicsService } from '../services/mechanics.service';
import { UtilsService } from '../services/utils.service';

@Component({
    selector: 'modal-inaccuracies',
    templateUrl: './modal-inaccuracies.component.html',
    styleUrls: ['./modal-inaccuracies.component.styl'],
    standalone: false
})
export class ModalInaccuraciesComponent implements OnInit {

	constructor(public ms: MechanicsService,
		public utils: UtilsService) { }

	ngOnInit() {
	}


	isFormValid() {
		return !!(this.ms.reportInaccuraciesForm.from.length > 4
			&& this.ms.reportInaccuraciesForm.message.length > 10)
	}

}
